import React from 'react';
import { connect } from 'react-redux'
import NuevaSolicitudTipoEmpresa from './NuevaSolicitudTipoEmpresa';

////Importación de actions.
import {
    getScreenData,
    routting,
    cancel,
    selectRadioButton,
    showError,
    routeToCancel,
    actualizarEstadoGlobal,
    routeToPrevious,
    resetStateSolicitudTipoEmpresa,
    routeToNuevaSolicitudCuenta,
    resetRedirectTipoEmpresa,
    deselectTipoEmpresa,
    routeToVistaCliente,
    routeToAdministradora,
    routeToEmpresa
} from '../actions/NuevaSolicitudTipoEmpresaActions';


const mapStateToProps = (state) => {
    return {
        data: state.nuevaSolicitudTipoEmpresa,
        tarjetas: state.tarjetas
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getScreenData: (currentScope) => {
            dispatch(getScreenData(currentScope));
        },
        routeToPrevious: () => {
            dispatch(routeToPrevious());
        },
        cancel: () => {
            dispatch(cancel());
        },
        selectRadioButton: (id, codigo, descripcion) => {
            dispatch(selectRadioButton(id, codigo, descripcion));
        },
        showError: () => {
            dispatch(showError());
        },
        actualizarEstadoGlobal: () => {
            dispatch(routeToCancel());
        },
        resetStateSolicitudTipoEmpresa: () => {
            dispatch(resetStateSolicitudTipoEmpresa());
        },
        routeToNuevaSolicitudCuenta: (tipoEmpresa) => {
            dispatch(routeToNuevaSolicitudCuenta(tipoEmpresa));
        },
        routeToEmpresa: () => {
            dispatch(routeToEmpresa());
        },
        resetRedirectTipoEmpresa: () => {
            dispatch(resetRedirectTipoEmpresa());
        },
        deselectTipoEmpresa: () => {
            dispatch(deselectTipoEmpresa());
        },
        routeToVistaCliente: () => {
            dispatch(routeToVistaCliente());
        },
        routeToAdministradora: () => {
            dispatch(routeToAdministradora());
        }
    }
}

//Connect entre el componente y las props y actions.
const NuevaSolicitudTipoEmpresaContainer = connect(mapStateToProps, mapDispatchToProps)(NuevaSolicitudTipoEmpresa);

export default NuevaSolicitudTipoEmpresaContainer;
